import SearchBarComponentImport from './SearchBar.component';
import SearchBarProperties from '../../propertyPanel/ComponentProperties/SearchBarProperties';
import { registerComponent } from '../registry';
import './SearchBar.css';

// 컴포넌트 등록
registerComponent({
  type: 'SEARCH_BAR',
  name: '검색창',
  component: SearchBarComponentImport,
  properties: SearchBarProperties,
  defaultProps: {
    skin: 'modern',
    placeholder: '검색어를 입력하세요',
    buttonText: '검색',
    searchPath: '/searched',
    showIcon: true,
    inputHeight: '50px',
    primaryColor: '#007bff',
    buttonColor: '#007bff',
    buttonTextColor: '#ffffff',
    borderRadius: '25px',
    fullWidth: true,
    showShadow: true,
    showSuggestions: false,
    className: ''
  },
  category: 'UI Components',
  icon: 'fa-search',
  description: 'URL 파라미터와 연동되는 검색창 컴포넌트'
});

// 컴포넌트 내보내기
export const SearchBarComponent = SearchBarComponentImport;
export default SearchBarComponentImport;